import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';

import { CommonMediaQueries, MediaScreenService } from '@rp/shared/services';

export const mediaGuard = (breakpoint: CommonMediaQueries, max?: boolean): CanActivateFn => {
  return () => {
    const mediaScreenService = inject(MediaScreenService);

    return mediaScreenService.isMatched(breakpoint, max);
  };
};
